import { useEffect, useState } from 'react'

import { Checkbox } from '@material-ui/core'
import BasicTable from 'Components/UI/Atoms/BasicTable'

export const WafersTable = (props) => {
  const { formEdit, edit, setFormEdit, data, estado } = props
  const [selectedRows, setSelectedRows] = useState([])
  const [allSelected, setAllSelected] = useState(false)

  const handleSelectAll = (event) => {
    setAllSelected(event.target.checked)
    if (event.target.checked) {
      const allRowIds = formEdit.map((row) => row.conf_obleas)
      setSelectedRows(allRowIds)
    } else {
      setSelectedRows([])
    }
  }

  useEffect(() => {
    const initialSelectedRows = data.filter((row) => row.oblea === 0).map((row) => row.conf_obleas)
    setSelectedRows(initialSelectedRows)
  }, [data])

  const handleCheckboxChange = (event, confObleas) => {
    let newSelectedRows = []
    const isChecked = event.target.checked

    if (isChecked) {
      newSelectedRows = [...selectedRows, confObleas]
    } else {
      newSelectedRows = selectedRows.filter((rowId) => rowId !== confObleas)
    }
    setSelectedRows(newSelectedRows)
    setAllSelected(newSelectedRows.length === formEdit.length)

    setFormEdit((prevFormEdit) =>
      prevFormEdit.map((item) =>
        item.conf_obleas === confObleas ? { ...item, check: isChecked } : item
      )
    )
  }

  return (
    <div style={{ overflowX: 'auto', height: '500px', maxHeight: '100%', margin: '20px' }}>
      <BasicTable
        col={[
          {
            title: (
              <Checkbox
                checked={allSelected}
                onChange={handleSelectAll}
                color="primary"
                disabled={estado === 'Pendiente de revisión' ? !edit : true}
              />
            ),
            style: { width: '40px' },
          },
          { title: 'Pieza', style: { width: '80px' } },
          { title: 'Oblea', style: { width: '80px' } },
          {
            title: (
              <span style={{ fontSize: '0.85rem', color: '#555' }}>
                Seleccionadas: {selectedRows.length}
              </span>
            ),
            style: { width: '80px' },
          },
        ]}
        size="small"
        rows={formEdit.map((row) => {
          return {
            checkbox: (
              <Checkbox
                checked={selectedRows.includes(row.conf_obleas)}
                onChange={(e) => handleCheckboxChange(e, row.conf_obleas)}
                color="primary"
                disabled={estado === 'Pendiente de revisión' ? !edit : true}
              />
            ),
            pieza: row.pieza,
            oblea: row.oblea,
            select: '',
          }
        })}
      />
    </div>
  )
}
